import { GenerateSubSelector } from '../spaceKeyedSelectors';
import { IActivityState } from './ActivityReducer';
import { createSelector } from 'reselect';

export const SelectActivityState = GenerateSubSelector<IActivityState>('activity');

export const selectActivities = createSelector(SelectActivityState, res => res.activities);
